module.exports = __webpack_public_path__ + "pk.f85a28f97edcb65c1e58.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pk.svg
// module chunks = styles